export default __webpack_public_path__ + "static/media/A.96e46112.wav";